import { createFileRoute } from '@tanstack/react-router';
import { AdminUsersScreen } from '@/features/admin/AdminUsersScreen';

type Search = { email?: string; kitchen?: string };

/** The Users tab with the inline new-user form open. Beta requests deep
 *  links here with the request's email and kitchen filled in. */
export const Route = createFileRoute('/_app/admin/users/new')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    email: typeof s.email === 'string' ? s.email : undefined,
    kitchen: typeof s.kitchen === 'string' ? s.kitchen : undefined,
  }),
  component: () => {
    const { email, kitchen } = Route.useSearch();
    return <AdminUsersScreen invite={{ email, kitchen }} />;
  },
});
